export default "__VITE_ASSET__B3oLF5ew__"